import React from 'react';
import { Heading, Main, SectionLeft, SectionRight, SubHeading } from './reviewAndLodge.style';
import { Button } from '../../../components/uielements';
import { useNavigate } from 'react-router-dom';

import backgroundImg from '../../../assets/PNG/review-and-lodge.png';
import backgroundImgCompress from '../../../assets/PNG/review-and-lodge-compress.png';
import useImageLoader from '../../../hooks/useImageLoader';
import { IntlMessages } from '../../../helper/langHelper';

const ReviewAndLodge = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/documentUpload');
  };
  const reviewAndLodgeBg = useImageLoader(backgroundImgCompress, backgroundImg);

  return (
    <Main>
      <SectionLeft>
        <Heading>
          <IntlMessages id="review.lodge.title" />
        </Heading>
        <SubHeading>
          <IntlMessages id="review.lodge.subtitle" />
        </SubHeading>
        <Button onClick={handleClick}>
          {' '}
          <IntlMessages id="button.next" />
        </Button>
      </SectionLeft>
      <SectionRight bg={reviewAndLodgeBg} />
    </Main>
  );
};

export default ReviewAndLodge;
